import { useSelector } from 'react-redux';
import GlobalSelectors from '../../store/global-selectors';
import { TRUSTED } from '../../constants/account-information';
import { MINIMUM_PURCHASE_AMT } from '../../pages/settings/payment-and-subscription/components/constants/add-funds-constants';

export const useFundLimitRemaining = () => {
  // TODO: this needs to figure out if the purchase is directly related to AP-backed wallets or not
  const { limitRemaining, trustLevel } = useSelector(GlobalSelectors.selectAccountInformationAccountInformation) || {};

  if (trustLevel === TRUSTED) {
    return Number.MAX_VALUE;
  }

  return limitRemaining;
};

export const useShouldAllowPurchase = (fundAmount) => {
  const limitRemaining = useFundLimitRemaining();

  if (fundAmount !== undefined) {
    return limitRemaining >= fundAmount && fundAmount >= MINIMUM_PURCHASE_AMT;
  }

  return limitRemaining >= MINIMUM_PURCHASE_AMT;
};
